export default __webpack_public_path__ + "static/media/fig3.cad41137.jpg";